import { Observable, of, Subject } from 'rxjs'

export const signUpModal$ = new Subject<boolean>()
export const openSignUpModal = () => signUpModal$.next({ open: true })
export const closeSignUpModal = () => signUpModal$.next({ open: false })
